module.exports = __webpack_public_path__ + "img/s5CardBottomLogo1.aaa10a29.svg";